// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import {Link} from 'react-router-dom';
import { withRouter } from 'react-router';
import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';
import {List, ListItem} from 'material-ui/List';
import Divider from 'material-ui/Divider';
import {GridList, GridTile} from 'material-ui/GridList';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import RaisedButton from 'material-ui/RaisedButton';
import Popover from 'material-ui/Popover';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import EditIcon from 'material-ui/svg-icons/image/edit';
import IconButton from 'material-ui/IconButton';
import Dialog from 'material-ui/Dialog';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import TournamentStructure from '../tournamentStructure';
import TournamentCompetition from '../tournamentCompetition';
import AddTournamentTeam from '../viewCompetitionTeam';
import ViewFixture from '../viewFixtureSession';
import AddMatch from '../addTournamentFixture';
import AddRegistration from '../addTournamentRegistration';
import ViewCompetitionExpense from '../viewCompetitionExpense';
import ViewCompetitionGallery from '../viewCompetitionGallery';
import ViewCompetitionRegistration from '../viewCompetitionRegistration';
import moment from 'moment';
import MatchList from '../viewCompetitionMatches';
import ResponseLeads from '../../responseLeads'
import { bindActionCreators } from 'redux';
import { connect }            from 'react-redux';
import * as actions           from '../../../../redux/modules/actions';
import Modal from 'react-modal';


const customStyles = {
  content : {
    top                   : '13%',
    left                  : '3%',
    right                 : '3%',
    bottom                : '3%',  
  },
    overlay: {
     background: "grey",
     overflow: 'hidden',
     position: 'fixed',
     zIndex   : '15'
   }
};


class ViewCompetition extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      section:props.match.params.section,
      tournament :'',
      tournament: {},
      data_uploaded: false,
      data_error: false,
      venues: [],
      game_types: [],
      open: false,
      dialog_open: false,
      basicInfoView:true,
      designAndMarketingView:false,
      resigtrationView:false,
      fixtureView:false,
      galleryView:false,
      expenseView:false,
      competition_details:[],
      addNewCompetitionView:false,
      showStructure:true,
      addTeamView:true,
      addStructureView:false,
      createFixtureView:false,
      editCompetitionView:false,
      addMemberView:false,
      addExpenseView:false,
      leadView:true,
      registrationView:false,
      openModal:false,
      registrationModel:false
    };
    this.getCompetition = this.getCompetition.bind(this);
    this.handleModal = this.handleModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  handleClick = (event) => {
    // This prevents ghost click.
    event.preventDefault();

    this.setState({
      open: true,
      anchorEl: event.currentTarget,
    });
  };

  handleModal=(event)=>{
    console.log('handleModal..')
    this.setState({openModal:true});
  }
  closeModal() {
      this.setState({openModal: false});
    }

  openRegistrationModal=(event)=>{
    console.log('openRegistrationModal..')
    this.setState({registrationModel:true});
  }
  closeRegistrationModal() {
      this.setState({registrationModel: false});
    }    

  componentDidMount() {
    this.getCompetition();

    
  }

  onTabClick(tabname){
    //TODO - commenting for now.
    this.props.history.push("/crud/viewCompetition/" + this.state.id +"/" + tabname)
    this.setState({
      section: tabname,
    });
  }

  // onbasicInfoClick(){
  //   this.props.history.push("/crud/viewCompetition/" + this.state.id +"/basicInfo")
  // }
  // onMarketingDesignClick(){
  //   this.props.history.push("/crud/viewCompetition/" + this.state.id +"/marketing")
  // }
  // onFixtureClick(){
  //   this.props.history.push("/crud/viewCompetition/" + this.state.id +"/fixture")
  // }
  // onExpenseClick(){
  //   this.props.history.push("/crud/viewCompetition/" + this.state.id +"/expense")
  // }
  // onGalleryClick(){
  //   this.props.history.push("/crud/viewCompetition/" + this.state.id +"/gallery")
  // }
  toAddStructureView(){
    this.setState({addStructureView:!this.state.addStructureView,createFixtureView:false,addMemberView:false});
  }
  toEditCompetitionView(){
    this.setState({editCompetitionView:!this.state.editCompetitionView})
  }
  onLeadView(){this.setState({leadView:true,registrationView:false})}
  onRegistrationsView(){this.setState({leadView:false,registrationView:true})}

  getCompetition(){
        var mobile_no = this.state.mobile_no
        const url = `${getLocationOrigin()}/tournament/get_competition/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                             'competition_id': this.state.id
                           });
        return fetch(url, options)
           .then(checkStatus)
           .then(parseJSON)
           .then(data => this.setState({competition_details: data.competitions_list,tournament:data.competitions_list[0].tournament}))
           .catch(error => {
             console.log(error);
             alert(error.message);
           });
  }
  

  


  render() {
    console.log('this.props')
    console.log(this.props)
    console.log(this.state)
    const actions = [
      <FlatButton
        label="Cancel"
        primary={true}
        onClick={this.handleClose}
      />,
      <FlatButton
        label="Submit"
        primary={true}
        onClick={this.handleCustomerSubmit}
      />,
      7350005899
    ];
    const okaction =  <input type="button" className="button1" value="Cancel" onClick={() => {this.toCreateFixtureView()}} />;
    

    return(
      <div>      
              <div className="col-md-12" >
                 <div className="breadcrumps" style={{'paddingLeft': "1%",'paddingTop':"1%"}}>
                        <a href={'/#/dashboard/ActiveCustomer'} >
                          <span>Dashboard</span>
                        </a> 
                        <a href={'/#/partnerTournament'} >
                          <span>Events</span>
                        </a>
                        <a href={"/#/crud/viewTournament/" + this.state.tournament.id} >
                          <span>{this.state.tournament.name}</span>
                        </a>
                        <a onClick={() =>{this.onTabClick('basicInfo')}}  >
                          <span>{this.state.competition_details.length > 0 &&  this.state.competition_details[0].category[1]+" " + this.state.competition_details[0].gender[1] + " " +this.state.competition_details[0].age_groups[1]}</span>
                        </a>
                        <a>
                              <span>{this.state.section}</span>
                        </a>
                  </div>
              </div>

              <div className="col-md-12" style={{padding:'1%'}}>
              <div className="col-md-12 " style={{'textAlign':"center",'display':"flex",'flexDirection':"row",'marginTop':"10px"}}> 
                  <div style={this.state.section == 'basicInfo' ? styles.active_header :styles.sub_header } onClick={() =>{this.onTabClick('basicInfo')}} >
                        <span className="heading2">Info & Basic Details </span>
                  </div>
                  {/*
                  <div style={this.state.section == 'marketing' ? styles.active_header :styles.sub_header} onClick={() =>{this.onTabClick('marketing')}}> 
                      <span className="heading2">Sales & Marketing </span>
                  </div>
                */}
                  <div style={this.state.section == 'fixture' ? styles.active_header :styles.sub_header} onClick={() =>{this.onTabClick('fixture')}}> 
                      <span className="heading2"> Teams and Fixture </span>
                  </div>
                  <div style={this.state.section == 'expense' ? styles.active_header :styles.sub_header} onClick={() =>{this.onTabClick('expense')}}> 
                      <span className="heading2">Expenses </span>
                  </div>
                  <div style={this.state.section == 'gallery' ? styles.active_header :styles.sub_header} onClick={() =>{this.onTabClick('gallery')}}>
                      <span className="heading2"> Gallery </span>
                  </div>
              </div>
              <div className="col-md-12" style={{padding:'8px','marginTop':'-8px'}}>
              <div  className="col-md-12" style={{'backgroundColor':"white"}}>
                          {this.state.section == 'basicInfo' &&
                            <div className="col-md-12 ">
                            {!this.state.editCompetitionView && this.state.competition_details.length > 0 &&
                              <div>
                                  <div className="col-md-12" style={{padding:'22px','textAlign':"right"}}>
                                      <input className="button1" type="button" value="Edit Competition" onClick={() => {this.toEditCompetitionView()}} />
                                  </div>
                                  <div className="col-md-12" style={{'paddingBottom':"10px",'borderBottom':"1px solid",display:'flex',flexDirection:'row'}} >
                                                    <div className="col-md-4"  >
                                                        <div style={{display:'flex',flexDirection:'row'}}>
                                                          <div className="col-md-6 heading2" style={styles.heading_div}>
                                                            Organiser : 
                                                          </div>
                                                          <div className="col-md-6" > {this.state.competition_details[0].coordinator.map((buddy,b)=>
                                                            <div>{buddy[1]}</div>)}
                                                          </div>
                                                        </div>
                                                        <div style={{display:'flex',flexDirection:'row'}}>
                                                          <div className="col-md-6 heading2" style={styles.heading_div}>
                                                          Start Date : 
                                                          </div>
                                                          <div className="col-md-6"> {this.state.competition_details[0].start_date[0]}</div>
                                                        </div>
                                                        <div style={{display:'flex',flexDirection:'row'}}>
                                                          <div className="col-md-6 heading2" style={styles.heading_div}>
                                                          End Date : 
                                                          </div>
                                                          <div className="col-md-6"> {this.state.competition_details[0].end_date[0]}</div>
                                                        </div>
                                                        <div style={{display:'flex',flexDirection:'row'}}>
                                                          <div className="col-md-6 heading2" style={styles.heading_div}>
                                                          Registrations Closed : 
                                                          </div>
                                                          <div className="col-md-6"> { this.state.competition_details[0].registration_closed[0]}</div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4" >
                                                      <div style={{display:'flex',flexDirection:'row'}}>
                                                        <div className="col-md-6 heading2" style={styles.heading_div}>
                                                          Game : 
                                                        </div>
                                                        <div className="col-md-6"> { this.state.competition_details[0].game[1]}</div>
                                                      </div>
                                                      <div style={{display:'flex',flexDirection:'row'}}> 
                                                        <div className="col-md-6 heading2" style={styles.heading_div}>
                                                          Gender : 
                                                        </div>
                                                        <div className="col-md-6"> { this.state.competition_details[0].gender[1]}
                                                        </div>
                                                      </div>
                                                      <div style={{display:'flex',flexDirection:'row'}}>
                                                        <div className="col-md-6 heading2" style={styles.heading_div}>
                                                          Category : 
                                                        </div>
                                                        <div className="col-md-6"> { this.state.competition_details[0].category[1]}
                                                        </div>
                                                      </div>
                                                      <div style={{display:'flex',flexDirection:'row'}}>
                                                        <div className="col-md-6 heading2" style={styles.heading_div}>
                                                          Age Group : 
                                                        </div>
                                                        <div className="col-md-6"> { this.state.competition_details[0].age_groups[1]}
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div className="col-md-4" >
                                                      <div style={{display:'flex',flexDirection:'row'}}>
                                                        <div className="col-md-6 heading2" style={styles.heading_div}>
                                                        Venues : 
                                                        </div>
                                                        <div className="col-md-6"> { this.state.competition_details[0].venue.map((venue,b)=>
                                                          <div>{venue[1]}</div>)}
                                                        </div>
                                                      </div>
                                                      <div style={{display:'flex',flexDirection:'row'}}>
                                                        <div className="col-md-6 heading2" style={styles.heading_div}>
                                                        Reg.  Amount: 
                                                        </div>
                                                        <div className="col-md-6"> { this.state.competition_details[0].registration_amount}
                                                        </div>
                                                      </div>
                                                      <div style={{display:'flex',flexDirection:'row'}}>
                                                        <div className="col-md-6 heading2" style={styles.heading_div}>
                                                        Prize and Perks : 
                                                        </div>
                                                        <div className="col-md-6" > { this.state.competition_details[0].prize_and_perks}
                                                        </div>
                                                      </div>
                                                    </div>
                                    </div>
                                      {/*
                                      <div className="col-md-12" style={{textAlign:'center'}}>
                                          <img id="banner" src={this.state.competition_details[0].banner} alt="Image 1" />
                                      </div>*/}
                                      {this.state.showStructure &&
                                          <TournamentStructure id={this.state.tournament.id} initialView={!this.state.basicInfoView} competitions_id={this.state.id} />
                                      }
                                      <div className="col-md-12" style={{'marginBottom':"50px",'marginLeft':"1%"}} >
                                        <div className="col-md-2 heading2" style={styles.heading_div}>
                                          Competition Description : 
                                        </div>
                                        <div className="col-md-10" >
                                        { this.state.competition_details[0].description}
                                        </div>
                                      </div>
                                </div>
                                }
                                  {this.state.editCompetitionView &&
                                  <div >
                                    <div className="col-md-12" style={{padding:'22px','textAlign':"right"}}>
                                      <input className="button" type="button" value="Show Details" onClick={() => {this.toEditCompetitionView()}} style={styles.input_button}/>
                                    </div>
                                    <TournamentCompetition  competitions_id={this.state.id} tournament_id={this.state.tournament.id}  view_type="edit" initialView={!this.state.basicInfoView} />
                                  </div>
                                  }
                                </div>
                              }
                              {this.state.section == 'marketing' &&
                              <div>
                                <div className="col-md-12" style={styles.button_view}> 
                                    <input type="button" className="button1" value="Leads" onClick={() => {this.onLeadView()}} />
                                    <input type="button" className="button1" value="Registrations" onClick={() => {this.onRegistrationsView()}} />
                                </div>
                                <div className="col-md-12" style={{'textAlign':"center",'marginBottom':"50px"}} >
                                  {this.state.leadView && 
                                      <ResponseLeads props={this.props} /> 
                                  }
                                  {this.state.registrationView && 
                                      <ViewCompetitionRegistration competition_id={this.state.id} />
                                  }
                                </div>
                              </div>
                              }
                              {this.state.section == 'fixture' &&
                                <div style={{'marginBottom':"20px",'marginTop':"20px"}}>
                                    <div  style={styles.button_view} >
                                      

                                      <input type="button" className="button1" value="Add Registration" onClick={() => {this.openRegistrationModal()}} />

                                      <input type="button" className="button1" style={{marginLeft:'10px'}} value="Add Match" onClick={() => {this.handleModal()}} />


                                        <Link to={"/crud/addCompetitionTeam/" + this.state.id}>
                                              <input className="button1" type="button" style={{marginLeft:'10%'}} value="Add Team"/>
                                        </Link>
                                    </div>
                                    {this.state.addTeamView && this.state.tournament.id &&
                                      <div>
                                      <AddTournamentTeam   id={this.state.tournament.id} competition_id={this.state.id}/>
                                      </div>
                                    }
                                    {
                                    <div>
                                        <MatchList id={this.state.tournament.id} competition_id={this.state.id} />
                                    </div>
                                    }
                                </div>
                              }
                              {this.state.section == 'expense' &&
                                <div className="col-md-12" style={{'textAlign':"center",'fontSize':"20px",'marginBottom':"20px"}} >                                  
                                  <ViewCompetitionExpense competition_id={this.state.id} />
                                </div>
                              }
                              {this.state.section == 'gallery' &&
                                <div className="col-md-12" style={{'textAlign':"center",'fontSize':"20px",'marginBottom':"20px"}} >
                                  <ViewCompetitionGallery competition_id={this.state.id} />
                                </div>
                              }
                      </div>
                </div>
        </div> 

        {this.state.openModal ?
          <div >
             <Modal 
                isOpen={this.state.openModal}
                onRequestClose={this.closeModal}
                style={customStyles}

              >
                <button className ="btn" onClick={this.closeModal} style={{color:'red',position:'absolute',right:-15,top:-5}}><i className="fa fa-close fa-2x" ></i></button>
                <AddMatch id={this.state.tournament.id} competitions_id={this.state.id}/>                                                    
              </Modal>
            </div>
            :
            ""
        }

        {this.state.registrationModel ?
          <div >
             <Modal 
                isOpen={this.state.registrationModel}
                onRequestClose={this.closeRegistrationModal}
                style={customStyles}

              >
                <button className ="btn" onClick={this.closeModal} style={{color:'red',position:'absolute',right:-15,top:-5}}><i className="fa fa-close fa-2x" ></i></button>
                <AddRegistration id={this.state.tournament.id} competition_id={this.state.id}/>                                                    
              </Modal>
            </div>
            :
            ""
        }

      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentView:  state.views.currentView,
    statsTable:             state.statsTable,
    scoreCard:              state.scoreCard,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions : bindActionCreators(
      {
        enterPage: actions.enterPage,
        leavePage: actions.leavePage,
        fetchScoreCardDataIfNeeded:   actions.fetchScoreCardDataIfNeeded,
        fetchStatsTableDataIfNeeded:  actions.fetchStatsTableDataIfNeeded,
      },
      dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ViewCompetition);



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/viewCompetition/index.js